import SVGIcon from "ui/icons/SVGIcon";
import type { IconStatusProps } from "./iconStatusTypes";

export default function IconWarning({ outline = false, ...props }: IconStatusProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <circle cx="8" cy="8" r="6" fill={outline ? "none" : "#F0C051"} stroke={outline ? "#F0C051" : "none"} />
      <path d="M8 5V8" stroke="#2E2E2E" strokeWidth="2" strokeLinecap="round" />
      <circle cx="8" cy="11" r="1" fill="#2E2E2E" />
    </SVGIcon>
  );
}
